/* eslint-disable */

export default function init(Blockly, profile, img_path) {
  Blockly.Blocks.infrared = {};
  Blockly.Blocks.infrared.style = "infrared_blocks";
  
  Blockly.Blocks.infrared_irtx_multi = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.infrared.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.IR)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/actuator_ir.svg", 50, 50)
        )
        .appendField(Blockly.Msg.IR_TX)
        .appendField(Blockly.Msg.IR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].ir_tx),
          "PIN"
        );
      this.appendDummyInput("")
        .appendField(Blockly.Msg.IR_TX_PROTOCOL)
        .appendField(
          new Blockly.FieldDropdown([
            ["RC5", "RC5"],
            ["RC6", "RC6"],
            ["NEC", "NEC"],
            ["SONY", "SONY"],
            ["JVC", "JVC"],
            ["SAMSUNG", "SAMSUNG"],
            ["WHYNTER", "WHYNTER"],
            ["AIWA", "AIWA"],
            ["LG", "LG"],
            ["DISH", "DISH"],
            ["DENON", "DENON"],
          ]),
          "PROTOCOL"
        );
      this.appendValueInput("CODE", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.IR_TX_CODE);
      this.appendValueInput("BITS", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.IR_TX_BITS);
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };

  Blockly.Blocks.infrared_irrx_multi = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.infrared.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.IR)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/sensor_irrx.svg", 100, 50)
        )
        .appendField(Blockly.Msg.IR_RX);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.IR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].ir_rx),
          "PIN"
        );
      this.setInputsInline(!0);
      this.setOutput(!0, "String");
    },
  };

  Blockly.Blocks.infrared_irtx_number = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.infrared.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.IR)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/actuator_ir.svg", 50, 50)
        )
        .appendField(Blockly.Msg.IR_TX_NUMBER)
        .appendField(Blockly.Msg.IR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].ir_tx),
          "PIN"
        );
      this.appendValueInput("DATA", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.IR_TX_DATA);
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
    },
  };

  Blockly.Blocks.infrared_irrx_number = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.infrared.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.IR)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/sensor_irrx.svg", 100, 50)
        )
        .appendField(Blockly.Msg.IR_RX_NUMBER);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.IR_PIN)
        .appendField(
          new Blockly.FieldDropdown(profile["default"].ir_rx),
          "PIN"
        );
      this.setInputsInline(true);
      this.setOutput(true, "Number");
    },
  };

}
